export const frNavbar = {
    //Modules
    'navbar.packagedOrders': 'Bons Plans',
    'navbar.operations': 'Plans de vente', //ONLY FLUIZY
    'navbar.survey': 'Sondages',
    'navbar.events': 'Évènements',
    'navbar.videos': 'Instant Digital',
    'navbar.actualites': 'Actualités',
    //Admin Modules
    'navbar.administrators': 'Utilisateurs siège',
    'navbar.teams': 'Équipes', //TEAMS
    'navbar.entities': 'Entités',
    'navbar.areas': 'Zones', // AREAS
    'navbar.sectors': 'Secteurs',
    'navbar.centers': 'Centres', //SHOPS
    'navbar.users': 'Collaborateurs',
    'navbar.stats': 'Stats',
    'navbar.tags': 'Tags',

    'navbar.no.permission.label': "Vous n'avez pas le droit d'accéder à ce module",
};
